import { all, AllEffect } from 'redux-saga/effects';
import AnalyticsReducer from './duck/reducer';
import { watchGetAnalytics } from './duck/saga';

function* AnalyticsSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetAnalytics()]);
}

export { AnalyticsReducer, AnalyticsSaga };
